export const WINDOW_VARIABLE_NAME = 'templateVariables'

export type AccountTemplateVariables = {
  customerToken: string
}

const templateVariables = typeof window !== 'undefined' ? window[WINDOW_VARIABLE_NAME as keyof Window] ?? {} : {}

export const accountTemplateVariables = templateVariables as Readonly<AccountTemplateVariables>
